import Charge from './charge';
export default class OffenseRecord {

  constructor(public requestNbr: number,
    public offenseNbr: number,
    public offenseDt: Date,
    public fileDt: Date,
    public dispositionDt: Date,
    public gradingResult: string,
    public courtRecordedName: string,
    public faxInfoInd: string,
    public identifierDOB: string,
    public identifierSSN: string,
    public identifierName: string,
    public identifierAddress: string,
    public identifierDLN: string,
    public classification: number,
    public comments: string,
    public referenceNbr: string,
    public nameDiff: string,
    public identifierSIN: string,
    public courtRecordDOB: Date,
    public identifierPartialDOB: string,
    public partialMonth: string,
    public partialDay: string,
    public partialYear: string,
    public identifierNoDOB: string,
    public nextCourtDate: Date,
    public probation: string,
    public jailTime: string,
    public prisonTime: string,
    public suspensionTime: string,
    public fines: string,
    public courtCosts: string,
    public otherSentenceNotes: string,
    public arrestDate: Date,
    public results: string,
    public suppressed: string,
    public deleted: string,
    public deferred: string,
    public isCourtCaseSentencing: string,
    public verifiedDOBFull: string,
    public verifiedDOBPartial: string,
    public verifiedAddress: string,
    public verifiedSSN: string,
    public verifiedSIN: string,
    public verifiedDL: string,
    public verifiedName: string,
    public isVerified: string,
    public verifiedUserId: number,
    public charges: Charge[],
    public isNewRecord = false) {
      if (courtRecordDOB != null) {
        this.courtRecordDOB.setHours(0, 0, 0, 0);
      }

      if (nextCourtDate != null) {
        this.nextCourtDate.setHours(0, 0, 0, 0);
      }

      if (nextCourtDate != null) {
        this.nextCourtDate.setHours(0, 0, 0, 0);
      }

      if (fileDt != null) {
        this.fileDt.setHours(0, 0, 0, 0);
      }

      if (dispositionDt != null) {
        this.dispositionDt.setHours(0, 0, 0, 0);
      }
    }

  get requestNumber(): number {
    return this.requestNbr;
  }

  get offenseNumber(): number {
    return this.offenseNbr;
  }

  get offenseDate(): Date {
    return this.offenseDt;
  }

  set offenseDate(offenseDate: Date) {
    if (offenseDate != null) {
      offenseDate.setHours(0, 0, 0, 0);
    }

    this.offenseDt = offenseDate;
  }

  get fileDate(): Date {
    return this.fileDt;
  }

  set fileDate(fileDate: Date) {
    if (fileDate != null) {
      fileDate.setHours(0, 0, 0, 0);
    }

    this.fileDt = fileDate;
  }

  get dispositionDate(): Date {
    return this.dispositionDt;
  }

  set dispositionDate(dispositionDate: Date) {
    if (dispositionDate != null) {
      dispositionDate.setHours(0, 0, 0, 0);
    }

    this.dispositionDt = dispositionDate;
  }

  get courtRecordFullName(): string {
    return this.courtRecordedName;
  }

  set courtRecordFullName(courtRecordFullName: string) {
    this.courtRecordedName = courtRecordFullName;
  }

  get hasFaxInformation(): boolean {
    return this.faxInfoInd === 'o';
  }

  set hasFaxInformation(hasFaxInformation: boolean) {
    this.faxInfoInd = hasFaxInformation ? 'o' : '';
  }

  get hasDobIdentifier(): boolean {
    return this.identifierDOB === 'o';
  }

  set hasDobIdentifier(hasDobIdentifier: boolean) {
    this.identifierDOB = hasDobIdentifier ? 'o' : '';
  }

  get hasSsnIdentifier(): boolean {
    return this.identifierSSN === 'o';
  }

  set hasSsnIdentifier(hasSsnIdentifier: boolean) {
    this.identifierSSN = hasSsnIdentifier ? 'o' : '';
  }

  get hasNameIdentifier(): boolean {
    return this.identifierName === 'o';
  }

  set hasNameIdentifier(hasNameIdentifier: boolean) {
    this.identifierName = hasNameIdentifier ? 'o' : '';
  }

  get hasAddressIdentifier(): boolean {
    return this.identifierAddress === 'o';
  }

  set hasAddressIdentifier(hasAddressIdentifier: boolean) {
    this.identifierAddress = hasAddressIdentifier ? 'o' : '';
  }

  get hasDlnIdentifier(): boolean {
    return this.identifierDLN === 'o';
  }

  set hasDlnIdentifier(hasDlnIdentifier: boolean) {
    this.identifierDLN = hasDlnIdentifier ? 'o' : '';
  }

  get hasSinIdentifier(): boolean {
    return this.identifierSIN === 'o';
  }


  set hasSinIdentifier(hasSinIdentifier: boolean) {
    this.identifierSIN = hasSinIdentifier ? 'o' : '';
  }

  get hasPartialDobIdentifier(): boolean {
    return this.identifierPartialDOB === 'o';
  }

  set hasPartialDobIdentifier(hasPartialDobIdentifier: boolean) {
    this.identifierPartialDOB = hasPartialDobIdentifier ? 'o' : '';
  }

  get hasNoDobIdentifier(): boolean {
    return this.identifierNoDOB === 'o';
  }

  set hasNoDobIdentifier(hasNoDobIdentifier: boolean) {
    this.identifierNoDOB = hasNoDobIdentifier ? 'o' : '';
  }

  get referenceNumber(): string {
    return this.referenceNbr;
  }

  set referenceNumber(referenceNumber: string) {
    this.referenceNbr = referenceNumber;
  }

  get nameDiffers(): boolean {
    return this.nameDiff === 'o';
  }

  set nameDiffers(nameDiffers: boolean) {
    this.nameDiff = nameDiffers ? 'o' : '';
  }

  get courtRecordDob(): Date {
    return this.courtRecordDOB;
  }

  set courtRecordDob(courtRecordDob: Date) {
    if (courtRecordDob != null) {
      courtRecordDob.setHours(0, 0, 0, 0);
    }

    this.courtRecordDOB = courtRecordDob;
  }

  get isSuppressed(): boolean {
    return this.suppressed === 'o';
  }

  set isSuppressed(isSuppressed: boolean) {
    this.suppressed = isSuppressed ? 'o' : '';
  }

  get isDeleted(): boolean {
    return this.deleted === 'o';
  }

  set isDeleted(isDeleted: boolean) {
    this.deleted = isDeleted ? 'o' : '';
  }

  get isDeferred(): boolean {
    return this.deferred === 'o';
  }

  set isDeferred(isDeferred: boolean) {
    this.deferred = isDeferred ? 'o' : '';
  }

  get isCourtCaseSentence(): boolean {
    return this.isCourtCaseSentencing === 'o';
  }

  set isCourtCaseSentence(isCourtCaseSentence: boolean) {
    this.isCourtCaseSentencing = isCourtCaseSentence ? 'o' : '';
  }

  get isVerifiedDobFull(): boolean {
    return this.verifiedDOBFull === 'o';
  }

  set isVerifiedDobFull(isVerifiedDobFull: boolean) {
    this.verifiedDOBFull = isVerifiedDobFull ? 'o' : '';
  }

  get isVerifiedDobPartial(): boolean {
    return this.verifiedDOBPartial === 'o';
  }

  set isVerifiedDobPartial(isVerifiedDobPartial: boolean) {
    this.verifiedDOBPartial = isVerifiedDobPartial ? 'o' : '';
  }

  get isVerifiedAddress(): boolean {
    return this.verifiedAddress === 'o';
  }

  set isVerifiedAddress(isVerifiedAddress: boolean) {
    this.verifiedAddress = isVerifiedAddress ? 'o' : '';
  }

  get isVerifiedSsn(): boolean {
    return this.verifiedSSN === 'o';
  }

  set isVerifiedSsn(isVerifiedSsn: boolean) {
    this.verifiedSSN = isVerifiedSsn ? 'o' : '';
  }

  get isVerifiedSin(): boolean {
    return this.verifiedSIN === 'o';
  }

  set isVerifiedSin(isVerifiedSin: boolean) {
    this.verifiedSIN = isVerifiedSin ? 'o' : '';
  }

  get isVerifiedDl(): boolean {
    return this.verifiedDL === 'o';
  }

  set isVerifiedDl(isVerifiedDl: boolean) {
    this.verifiedDL = isVerifiedDl ? 'o' : '';
  }

  get isVerifiedName(): boolean {
    return this.verifiedName === 'o';
  }

  set isVerifiedName(isVerifiedName: boolean) {
    this.verifiedName = isVerifiedName ? 'o' : '';
  }

  get isOffenseVerified(): boolean {
    return this.isVerified === 'o';
  }

  set isOffenseVerified(isOffenseVerified: boolean) {
    this.isVerified = isOffenseVerified ? 'o' : '';
  }

  static getFromRequest(offenseRecords: any): OffenseRecord[] {
    if (offenseRecords == null) {
      return null;
    }

    const records = new Array<OffenseRecord>();
    if (offenseRecords.length > 0) {
      for (const offenseRecord of offenseRecords) {
        records.push(new OffenseRecord(offenseRecord.requestNbr,
          offenseRecord.offenseNbr,
          offenseRecord.offenseDt === null ? null : new Date(offenseRecord.offenseDt),
          offenseRecord.fileDt === null ? null : new Date(offenseRecord.fileDt),
          offenseRecord.dispositionDt === null ? null : new Date(offenseRecord.dispositionDt),
          offenseRecord.gradingResult,
          offenseRecord.courtRecordedName,
          offenseRecord.faxInfoInd,
          offenseRecord.identifierDOB,
          offenseRecord.identifierSSN,
          offenseRecord.identifierName,
          offenseRecord.identifierAddress,
          offenseRecord.identifierDLN,
          offenseRecord.classification,
          offenseRecord.comments,
          offenseRecord.referenceNbr,
          offenseRecord.nameDiff,
          offenseRecord.identifierSIN,
          offenseRecord.courtRecordDOB === null ? null : new Date(offenseRecord.courtRecordDOB),
          offenseRecord.identifierPartialDOB,
          offenseRecord.partialMonth,
          offenseRecord.partialDay,
          offenseRecord.partialYear,
          offenseRecord.identifierNoDOB,
          offenseRecord.nextCourtDate === null ? null : new Date(offenseRecord.nextCourtDate),
          offenseRecord.probation,
          offenseRecord.jailTime,
          offenseRecord.prisonTime,
          offenseRecord.suspensionTime,
          offenseRecord.fines,
          offenseRecord.courtCosts,
          offenseRecord.otherSentenceNotes,
          offenseRecord.arrestDate === null ? null : new Date(offenseRecord.arrestDate),
          offenseRecord.results,
          offenseRecord.suppressed,
          offenseRecord.deleted,
          offenseRecord.deferred,
          offenseRecord.isCourtCaseSentencing,
          offenseRecord.verifiedDOBFull,
          offenseRecord.verifiedDOBPartial,
          offenseRecord.verifiedAddress,
          offenseRecord.verifiedSSN,
          offenseRecord.verifiedSIN,
          offenseRecord.verifiedDL,
          offenseRecord.verifiedName,
          offenseRecord.isVerified,
          offenseRecord.verifiedUserId,
          Charge.createFromRequest(offenseRecord.charges)));
      }
    }

    return records;
  }

  static createNewOffenseRecord(requestNumber: number, offenceNumber): OffenseRecord {
    return new OffenseRecord(requestNumber, offenceNumber, null, null, null, null, null,
      null, null, null, null, null, null, null,
      null, null, null, null, null, null, null,
      null, null, null, null, null, null, null,
      null, null, null, null, null, null, null,
      null, null, null, null, null, null, null,
      null, null, null, null, null, new Array<Charge>(),
      true);
  }
}



// WEBPACK FOOTER //
// ./src/models/offenseRecord.ts